var _g, _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXml(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3159_69216)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C2.44772 0 2 0.447716 2 1V23C2 23.5523 2.44772 24 3 24H21C21.5523 24 22 23.5523 22 23V4L18 0H3Z",
    fill: "#E9F0FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0V4H22L18 0Z",
    fill: "#C2CDDE"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10,
    width: 22,
    height: 10,
    rx: 1,
    fill: "#125C0C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8022 12.1818L6.08345 14.3125H6.12891L7.41584 12.1818H8.61754L6.82493 15.0909L8.64595 18H7.42436L6.12891 15.8835H6.08345L4.788 18H3.57209L5.41016 15.0909L3.59482 12.1818H4.8022ZM9.44496 12.1818H10.7347L12.462 16.3977H12.5302L14.2575 12.1818H15.5472V18H14.5359V14.0028H14.4819L12.8739 17.983H12.1183L10.5103 13.9943H10.4563V18H9.44496V12.1818ZM16.695 18V12.1818H17.7489V17.1165H20.3114V18H16.695Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3159_69216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24,
    fill: "white",
    transform: "translate(2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXml);
export default __webpack_public_path__ + "static/media/xml.5ea3d8f7f0288e27224564b690c492de.svg";
export { ForwardRef as ReactComponent };